import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { getAuth, getIdToken } from '@angular/fire/auth';

import { Firestore, collection, collectionData, doc, docData, query, where,getCountFromServer } from '@angular/fire/firestore';
import { BehaviorSubject, Observable,from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';



export interface BillingData {
    id?: string;
  currentAvailable: number;
  lastUpdated: string; // or Date if you convert
}

@Injectable({
  providedIn: 'root'
})


 


export class Conversation {


  _templates = new BehaviorSubject<any[]>([]);

  constructor(private firestore: Firestore,private http: HttpClient) {}

  /**
   * Get conversations with optional field filter and date range.
   * @param filterField - Firestore field name to filter by (optional)
   * @param filterValue - Value to match for the field (optional)
   * @param startDate - Start date (ISO string or Date)
   * @param endDate - End date (ISO string or Date)
   */

  getConversations(
    filterField?: string,
    filterValue?: any,
    startDate?: Number,
    endDate?: Number
  ): Observable<any[]> {
    const conversationsRef = collection(this.firestore, `${environment.prefix}conversation_state`);
    const constraints: any[] = [];

    // Apply field filter
    if (filterField && filterValue) {
      constraints.push(where(filterField, '==', filterValue));
    }

    // Apply date range filter (using updatedAt)
    if (startDate) {
      const start = startDate instanceof Date ? startDate.toISOString() : startDate;
      constraints.push(where('lastMessage', '>=', start));
    }

    if (endDate) {
      const end = endDate instanceof Date ? endDate.toISOString() : endDate;
      constraints.push(where('lastMessage', '<=', end));
    }

    // console.log(constraints)

    // Build query
    const conversationsQuery = query(conversationsRef, ...constraints);

    // Fetch + sort
    return collectionData(conversationsQuery, { idField: 'id' }).pipe(
      map((conversations) =>
        conversations.sort((a, b) => {
          const aTime = a['lastMessage'] || a['updatedAt'] || a['createdAt'] || 0;
          const bTime = b['lastMessage'] || b['updatedAt'] || b['createdAt'] || 0;
          return bTime - aTime;
        })
      )
    );
  }


async  getTotalDocs(col) {
  const collectionRef = collection(this.firestore, `${environment.prefix}${col}`);
  const snapshot = await getCountFromServer(collectionRef);
  
  return snapshot.data().count;
}

//   getConversations(filterField?: string, 
//     filterValue?: any,
//    startDate?: Date | string,
//     endDate?: Date | string
//   ): Observable<any[]> {
//   const conversationsRef = collection(this.firestore, `${environment.prefix}conversation_state`);
//   let conversationsQuery;

//   if (filterField && filterValue) {
//     conversationsQuery = query(conversationsRef, where(filterField, '==', filterValue));
//   } else {
//     conversationsQuery = query(conversationsRef);
//   }

//   return collectionData(conversationsQuery, { idField: 'id' }).pipe(
//     map(conversations => conversations.sort((a, b) => {
//       // Sort by lastMessage if it exists, fallback to createdAt
//       const aTime = a['lastMessage']? a['lastMessage']: a['createdAt']|| 0;
//       const bTime = b['lastMessage'] ? b['lastMessage'] : b['createdAt'] || 0;
//       return bTime - aTime;
//     }))
//   );
// }

  // New method to fetch messages for a conversation
 getMessages(conversationId: string): Observable<any[]> {
    const messagesRef = collection(this.firestore, `${environment.prefix}conversation_state/${conversationId}/messages`);
    const messagesQuery = query(messagesRef);
    return collectionData(messagesQuery, { idField: 'id' }).pipe(
      map(messages => messages.sort((a, b) => new Date(b['updatedAt']).getTime() - new Date(a['updatedAt']).getTime()))
    );
  }

  getConversationState(conversationId: string){
        const stateRef = doc(this.firestore, `${environment.prefix}conversation_state/${conversationId}`);
        return docData(stateRef)
  }

  /**
   * Get a snapshot of a document in prod_billing collection by token
   */
  getBillingByToken(): Observable<BillingData> {
    const docRef = doc(this.firestore, `${environment.prefix}${environment.collections.BILLING}/tokens`);
    return docData(docRef, { idField: 'id' }) as Observable<BillingData>;
  }

   getVariables(): Observable<{}> {
    const docRef = doc(this.firestore, `${environment.prefix}${environment.collections.BILLING}/templates`);
    return docData(docRef, { idField: 'id' }) as Observable<BillingData>;
  }


  async postMessage(data:any, url:any, targetSubject?: BehaviorSubject<any[]> ) {
    try {
      const apiCallPromise = new Promise<void>(async (resolve, reject) => {
        (await this.apiPost(data, url)).subscribe({
          next: async (res:any) => {
            console.log(res)
            if (res['status'] === 'Success') {
              // console.log(res)
              if(targetSubject) targetSubject.next(res['data'])
              resolve(); // Resolve the promise when the API call is successful
            } else {
              console.log('Failed');
              reject('API call failed'); // Reject the promise if the API call fails
            }
          },
          error: (err:any) => {
            // console.error('Error:', err);
            reject(err); // Reject the promise if there's an error in the subscription
          }
        });
      });
  
      // Await the promise to ensure the API call completes before continuing
      await apiCallPromise;
    } catch (error) {
      // console.error('Error:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  }


  async apiPost(data:any, url:any) {
    
    const auth = getAuth()
    const { currentUser } = auth
    const accessToken = await getIdToken(currentUser, true)
    // console.log('User id:',currentUser.uid, ' Member id: ', data)
    data.env = environment.prefix
    if(!data.uid){
    data.uid = currentUser.uid
    }
   
    
    const fullUrl=  environment.apiUrl + url;
    let headers;
    headers = { Authorization: 'Bearer ' + accessToken };
    headers.env = environment.prefix;
    headers.uuid = currentUser.uid;
    // console.log(data)
    return this.http.post(fullUrl, data, {headers});
  }


  //fetch Users
   getUsers(): Observable<any[]> {
    const userRef = collection(this.firestore, `${environment.prefix}${environment.collections.USERS}`);
    const userQuery = query(userRef);
    return collectionData(userQuery, { idField: 'id' }).pipe(
      map(user => user.sort((a, b) => new Date(b['updatedAt']).getTime() - new Date(a['updatedAt']).getTime()))
    );
  }


  getCategoryDistribution(startDate: string, endDate: string): Observable<any> {
  return this.apiGet('category-distribution', { startDate, endDate });
}

getOutcomeDistribution(startDate: string, endDate: string): Observable<any> {
  return this.apiGet('outcome-distribution', { startDate, endDate });
}

getOutcomeRate(startDate: string, endDate: string): Observable<any> {
  return this.apiGet('outcome-rate', { startDate, endDate });
}

getEngagementFrequency(startDate: string, endDate: string): Observable<any> {
  return this.apiGet('engagement-frequency', { startDate, endDate });
}

getCrossTab(startDate: string, endDate: string): Observable<any> {
  return this.apiGet('cross-tab', { startDate, endDate });
}


getConversationExplorer(startDate: string, endDate: string): Observable<any> {
  return this.apiGet('conversation-explorer', { startDate, endDate });
}

getConversationDetails(startDate: string, endDate: string): Observable<any> {
  return this.apiGet('conversation-details', { startDate, endDate });
}

getRawDataExplorer(startDate: string, endDate: string): Observable<any> {
  return this.apiGet('raw-data-explorer', { startDate, endDate });
}



  private apiGet( endpoint: string, params: Record<string, string>): Observable<any> {

  const BASE_URL = `${environment.apiUrl}${environment.endpoints.BUSINESS_INTELLIGENECE}`;
  const auth = getAuth();
  const currentUser = auth.currentUser;

  return from(getIdToken(currentUser!, true)).pipe(
    switchMap((accessToken) => {
      // console.log(accessToken)
      const headers = new HttpHeaders({
        Authorization: `Bearer ${accessToken}`,
        env: environment.prefix,
        uuid: currentUser!.uid
      });

      return this.http.get(`${BASE_URL}/${endpoint}`, {
        params,
        headers
      });
    })
  );
}



}


//lastMessage